// uiSlice.js
export const createUISlice = (set, get) => ({
  // UI states
  isPreviewMode: false,
  isDirty: false, // Has unsaved changes
  isLoading: false,
  error: null,

  // Preview mode
  togglePreviewMode: () =>
    set((state) => ({ isPreviewMode: !state.isPreviewMode })),

  setPreviewMode: (isPreview) =>
    set({ isPreviewMode: isPreview }),

  // Error management
  clearError: () => set({ error: null }),

  setError: (error) => set({ error }),

  // Loading state
  setLoading: (isLoading) => set({ isLoading }),

  // Dirty state
  setDirty: (isDirty) => set({ isDirty }),
});